import React from 'react';
import Tag from '@app/component/tag/Tag';
import Utilities from '@util/Utilities';
import {
	findSentimentTagState,
} from '@app/site/secured/review-manager/fragment/property-overview/component/SentimentColors';

const ReviewScoreTag: React.FunctionComponent<{ score: number }> = ({ score }) => {

	const tagState = findSentimentTagState(score * 100);

	if (score > 0)
		return <Tag state={tagState}>{Utilities.formatDouble(score, 1)}</Tag>;
	else
		return '-';
};

export default ReviewScoreTag;